export default __webpack_public_path__ + "static/media/cook3.1c4809ba.png";